import { useTravelataApiService, useTravelataAppConfig } from '@/shared/composables';
import { useSentryService } from '@/shared/di';
import { type BaseResponse } from '@/shared/model';
import type { CreateSubscriptionPayload } from './types';

export const createSubscription = async (data: CreateSubscriptionPayload): Promise<void> => {
  const sentryService = useSentryService();
  const apiService = useTravelataApiService();
  const appConfig = useTravelataAppConfig();
  try {
    const response = await apiService.post<BaseResponse, CreateSubscriptionPayload>(
      `${appConfig.apiGatewayUrl}/frontend/subscriptions`,
      data,
      {
        headers: {
          'Content-type': 'application/json; charset=utf-8',
        },
      },
    );
    if (!response.success) {
      throw new Error('api-gateway/frontend/subscriptions success false');
    }
  } catch (error) {
    const message = error instanceof Error ? error.message : 'Неизвестная ошибка';
    sentryService.captureException(`Ошибка подписки api-gateway/frontend/subscriptions: ${message}`);
    throw new Error(message);
  }
};
